import React from 'react';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
export function ScrollProgress() {
  const {
    scrollYProgress,
    scrollY
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const opacity = useTransform(scrollY, [0, 100], [0, 1]);
  return <motion.div className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#E8781A] to-[#a855f7] z-[60] origin-left" style={{
    scaleX,
    opacity
  }} data-id="element-172" />;
}